import { render, staticRenderFns } from "./LogoSignature5SecondVideosSection.vue?vue&type=template&id=fd1963aa"
import script from "./LogoSignature5SecondVideosSection.vue?vue&type=script&lang=ts"
export * from "./LogoSignature5SecondVideosSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSignature5SecondVideosSection.vue?vue&type=style&index=0&id=fd1963aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports